var _excluded = ["sentiment", "value", "totalValue", "format", "title", "unit", "textTransform", "icon", "tooltip"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Stack, Icon, Columns } from "./..";
import { StatisticContainer, StatisticValue, StatisticTitle } from "./BaseStatistic";

var getColor = function getColor(sentiment) {
  switch (sentiment) {
    case 'success':
      return 'green.500';

    case 'danger':
      return 'orange.500';

    case 'neutral':
    default:
      return 'grey.800';
  }
};

var Statistic = function Statistic(_ref) {
  var sentiment = _ref.sentiment,
      value = _ref.value,
      totalValue = _ref.totalValue,
      format = _ref.format,
      title = _ref.title,
      unit = _ref.unit,
      textTransform = _ref.textTransform,
      icon = _ref.icon,
      tooltip = _ref.tooltip,
      others = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StatisticContainer, _extends({
    textTransform: textTransform,
    tooltip: tooltip
  }, others), /*#__PURE__*/React.createElement(Columns, {
    alignY: "center",
    space: "xSmall"
  }, icon ? /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    icon: icon
  }) : null, /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(StatisticTitle, {
    color: getColor(sentiment)
  }, title), /*#__PURE__*/React.createElement(StatisticValue, {
    valueFontSize: 3,
    valueLineHeight: 3,
    valueColor: getColor(sentiment),
    value: value,
    totalValue: totalValue,
    format: format,
    unit: unit
  }))));
};

Statistic.displayName = 'Statistic';
export { Statistic };
export default Statistic;